<template>
  <section>
    <v-dialog
      v-model="dialog"
      :width="notAttached? '1000px': '328px'">
      <div class="dialog-container">
        <h2>Attach Quote</h2>
        <section v-if="notAttached">
          <div class="abs-top-right">
            <v-button @click="dialog = false">Cancel</v-button>
            <v-button
              type="primary"
              @click="handlerSave">Attach</v-button>
          </div>
          <div class="filter-container">
            <div class="flex">
              <div class="filter-box">
                <span class="label">Search</span>
                <div class="search-box">
                  <v-input
                    v-model="search"
                    placeholder="Quotation No., Customer Name, Insurer, Referrer or Price"
                    @keyEnter="filterData" />
                </div>
              </div>
              <div class="filter-box">
                <span class="label">Quote Date</span>
                <div class="search-box">
                  <v-date-picker
                    v-model="date"
                    type="daterange"
                    @change="filterData" />
                </div>
              </div>
            </div>

            <div class="filter-box">
              <span class="label">
                Product Type
                <span
                  class="all"
                  @click="handlerSelectAll('product_id')">Select All</span>
              </span>
              <v-checkbox-group
                v-model="product_id"
                :list="productTypeOptions"
                @change="filterData"></v-checkbox-group>
            </div>
            <div class="filter-box">
              <span class="label">
                Insurer
                <span
                  class="all"
                  @click="handlerSelectAll('company_id')">Select All</span>
              </span>
              <v-checkbox-group
                v-model="company_id"
                :list="insurerOptions"
                @change="filterData"
              ></v-checkbox-group>
            </div>
            <div class="filter-box">
              <span class="label">
                Status
                <span
                  class="all"
                  @click="handlerSelectAll('stts')">Select All</span>
              </span>
              <v-checkbox-group
                v-model="stts"
                :list="statusOptions"
                @change="filterData"></v-checkbox-group>
            </div>
          </div>
          <!-- <div class="transparent"> -->
          <el-table
            :data="tableData"
            stripe
            style="width: 100%"
            @row-click="rowClick">
            <el-table-column width="55">
              <template slot-scope="scope">
                <span
                  :class="[selectIndex == scope.$index? 'radio-circle-checked': 'radio-circle' ]"
                ></span>
              </template>
            </el-table-column>
            <el-table-column
              prop="quote_dt"
              label="Date & Time"></el-table-column>
            <el-table-column
              prop="id"
              label="ID"></el-table-column>
            <el-table-column
              prop="product_type"
              label="Product Type"></el-table-column>
            <el-table-column
              prop="insurer"
              label="Insurer"></el-table-column>
            <el-table-column
              prop="price"
              label="Price"></el-table-column>
            <el-table-column
              prop="contact_nm"
              label="Contact Name"></el-table-column>
            <el-table-column
              prop="phone_no"
              label="Phone No."></el-table-column>
            <el-table-column
              prop="referrer_nm"
              label="Referrer"></el-table-column> 
            <el-table-column
              prop="policy_period"
              label="Policy Period"></el-table-column>
            <el-table-column
              prop="stts"
              label="Status"></el-table-column>
            <el-table-column width="55">
              <template slot-scope="scope">
                <v-button
                  type="text"
                  :stop="true"
                  @click="handlerView(scope.row)">View</v-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- </div> -->

          <v-pagination
            :total="pageConfig.total"
            :current="pageConfig.currentPage"
            @currentChange="currentChange"
          />
        </section>
        <section v-else>
          <p>The selected quote has been attached.</p>
          <div class="dialog-footer">
            <v-button
              type="primary"
              @click="handlerDone">Done</v-button>
          </div>
        </section>
      </div>
    </v-dialog>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import { getOrderList } from '@/api/order'
import { chooseTicketQuote } from '@/api/ticket'
export default {
  name: 'AttachQuote',
  mixins: [MixinOptions],
  props: {
    ticketId: [String, Number],
    customerId:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
      dialog: false,
      notAttached: true,
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      statusOptions: [
        {
          name: 'Quick Quote',
          id: 1
        },
        {
          name: 'Paid',
          id: 2
        }
      ],
      date: '',
      product_id: [],
      company_id: [],
      stts: [],
      search: '',
      tableData: [],
      selectIndex: -1
    }
  },
  watch: {
    // property: {
    //   immediate: true,
    //   handler() {
    //     this.network().getOrderList()
    //   }
    // },
    customerId:{
      immediate: true,
      handler(val) {
        this.network().getOrderList()
      }
    }
  },
  methods: {
    handlerSave() {
      const { tickets } = this.tableData[this.selectIndex]
      console.log('tickets',tickets)
      if(tickets) {
        this.notAttached = false
        return
      }
      if(this.selectIndex!=-1) {
        this.network().chooseTicketQuote()
      }
    },
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerSelectAll(target) {
      let origin = ''
      switch(target) {
        case 'product_id':
          origin = 'productTypeOptions'
          break
        case 'stts':
          origin = 'statusOptions'
          break
        case 'company_id':
          origin = 'insurerOptions'
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data
      this.filterData()
    },
    handlerView(row) {
      this.$router.push({
        path: '/records/quote/detail',
        query: {
          order_id: row.id,
          product_id: row.product_id
        }
      })
    },
    rowClick(row) {
      const { index } = row
      this.selectIndex = index
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getOrderList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getOrderList()
    },
    handlerDone() {
      this.notAttached = true
      this.dialog = false
    },
    network() {
      return {
        getOrderList: async () => {
          let params ={
            quote_dt_start: this.date[0],
            quote_dt_end: this.date[1],
            product_id: this.product_id,
            company_id: this.company_id,
            stts: this.stts,
            search: this.search,
            page: this.pageConfig.currentPage,
            hideLoading: true,
          }
          if(this.customerId!=0)
            params.customer_id = this.customerId
          let { data } = await getOrderList(params)
          data.data.map((item, index) => {
            item.index = index
            return item
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
          this.selectIndex = -1
        },
        chooseTicketQuote: async () => {
          const { data } = await chooseTicketQuote({
            ticket_id: this.ticketId,
            order_id: this.tableData[this.selectIndex].id
          })
          console.log('data',data)
          // 更新数据
          this.pageConfig.currentPage = 1
          this.network().getOrderList()

          this.dialog = false
          this.$emit('success')
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
    position: relative;
  padding: 15px;
  .abs-top-right {
      padding: 20px 15px;
  }
  p {
    padding-bottom: 15px;
  }
  .radio-circle {
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    border: 1px solid #d5d8de;
    background: white;
    cursor: pointer;
  }
  .radio-circle-checked {
    position: relative;
    display: inline-block;
    //   box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 100%;
    background: #409eff;
    &::before {
      position: absolute;
      content: "";
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 5px;
      height: 5px;
      border-radius: 100%;
      background: white;
    }
  }
  .filter-container {
     .filter-box {
      margin-bottom: 10px;
      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;
        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409eff;
          font-weight: 500;
          cursor: pointer;
        }
      }
      .search-box {
          margin-right: 20px;
        width: 400px;
      }
      .quote-box {
        width: 300px;
      }
    }
  }
}
</style>